export default __webpack_public_path__ + "static/media/how-to-1.6a1b5241.png";